import { ContractCategory } from 'compliance-api/generated';
import { SelectOption } from 'ui';

export const contractCategoryLabels: Record<ContractCategory, string> = {
  [ContractCategory.AgencyAgreement]: 'Agency Agreement',
  [ContractCategory.AgistmentAgreementAgriculture]: 'Agistment Agreement (Agriculture)',
  [ContractCategory.As2124As4000As4902StandardFormConstructionContracts]:
    'AS2124 / AS4000 / AS4902 (Standard Form Construction Contracts)',
  [ContractCategory.BindingFinancialAgreementBfaPreNuptial]:
    'Binding Financial Agreement (BFA / "Pre-nuptial")',
  [ContractCategory.BindingDeathBenefitNominationSuperannuation]:
    'Binding Death Benefit Nomination (Superannuation)',
  [ContractCategory.BuildingManagementStatementBms]: 'Building Management Statement (BMS)',
  [ContractCategory.CallOptionAgreementPutOptionAgreement]:
    'Call Option Agreement / Put Option Agreement',
  [ContractCategory.CharterpartyMaritimeShipping]: 'Charterparty (Maritime/Shipping)',
  [ContractCategory.ChildSupportAgreement]: 'Child Support Agreement',
  [ContractCategory.CommercialLease]: 'Commercial Lease',
  [ContractCategory.ConfidentialityDeedNonDisclosureAgreementNda]:
    'Confidentiality Deed / Non-Disclosure Agreement (NDA)',
  [ContractCategory.ConstructionContractMajorWorksOrResidentialHiaMba]:
    'Construction Contract (Major Works or Residential HIA/MBA)',
  [ContractCategory.ConsultancyAgreement]: 'Consultancy Agreement',
  [ContractCategory.ContractOfSaleLandRealEstate]: 'Contract of Sale (Land / Real Estate)',
  [ContractCategory.ContractOfSaleBusinessAssetSale]: 'Contract of Sale (Business / Asset Sale)',
  [ContractCategory.ConvertibleNote]: 'Convertible Note',
  [ContractCategory.CustomerTermsAndConditions]: 'Customer Terms and Conditions',
  [ContractCategory.DeedOfAccession]: 'Deed of Accession',
  [ContractCategory.DeedOfAppointmentResignationTrusts]:
    'Deed of Appointment / Resignation (Trusts)',
  [ContractCategory.DeedOfCrossGuaranteeAsic]: 'Deed of Cross Guarantee (ASIC)',
  [ContractCategory.DeedOfReleaseSettlementAgreement]: 'Deed of Release / Settlement Agreement',
  [ContractCategory.DeedOfVariation]: 'Deed of Variation',
  [ContractCategory.DesignAndConstructDAndCContract]: 'Design and Construct (D&C) Contract',
  [ContractCategory.DistributionAgreement]: 'Distribution Agreement',
  [ContractCategory.Division7ALoanAgreement]: 'Division 7A Loan Agreement',
  [ContractCategory.EasementAgreement]: 'Easement Agreement',
  [ContractCategory.EmploymentContract]: 'Employment Contract',
  [ContractCategory.EndUserLicenceAgreement]: 'End User Licence Agreement (EULA)',
  [ContractCategory.ExclusiveAgencyAgreementRealEstateSales]:
    'Exclusive Agency Agreement (Real Estate Sales)',
  [ContractCategory.FarminFarmoutAgreementMiningResources]:
    'Farmin / Farmout Agreement (Mining/Resources)',
  [ContractCategory.FranchiseAgreement]: 'Franchise Agreement',
  [ContractCategory.FundingAgreementGrantsOrGovernment]: 'Funding Agreement (Grants or Government)',
  [ContractCategory.GeneralSecurityAgreementGsaPpsr]: 'General Security Agreement (GSA / PPSR)',
  [ContractCategory.GuaranteeAndIndemnity]: 'Guarantee and Indemnity',
  [ContractCategory.HandshakeAgreementOralContract]: 'Handshake Agreement (Oral Contract)',
  [ContractCategory.HireAgreementEquipmentLease]: 'Hire Agreement / Equipment Lease',
  [ContractCategory.IndependentContractorAgreement]: 'Independent Contractor Agreement',
  [ContractCategory.InsurancePolicyPolicySchedule]: 'Insurance Policy / Policy Schedule',
  [ContractCategory.IntellectualPropertyAssignmentLicenceDeed]:
    'Intellectual Property Assignment / Licence Deed',
  [ContractCategory.JointVentureAgreementIncorporatedOrUnincorporated]:
    'Joint Venture Agreement (Incorporated or Unincorporated)',
  [ContractCategory.LicenceToOccupy]: 'Licence to Occupy',
  [ContractCategory.LoanAgreement]: 'Loan Agreement',
  [ContractCategory.ManagedServicesAgreementMsa]: 'Managed Services Agreement (MSA)',
  [ContractCategory.ManagementRightsAgreement]: 'Management Rights Agreement',
  [ContractCategory.ManufacturingAgreement]: 'Manufacturing Agreement',
  [ContractCategory.MasterServicesAgreement]: 'Master Services Agreement',
  [ContractCategory.MediaTalentRelease]: 'Media / Talent Release',
  [ContractCategory.MortgageAgreement]: 'Mortgage Agreement',
  [ContractCategory.OwnersCorporationManagementAgreement]:
    'Owners Corporation Management Agreement',
  [ContractCategory.PartnershipAgreement]: 'Partnership Agreement',
  [ContractCategory.PowerOfAttorneyEnduringOrGeneral]: 'Power of Attorney (Enduring or General)',
  [ContractCategory.PrivacyPolicyAgreement]: 'Privacy Policy Agreement',
  [ContractCategory.ProcurementAgreementPurchaseOrderTerms]:
    'Procurement Agreement / Purchase Order Terms',
  [ContractCategory.ReferralCommissionAgreement]: 'Referral / Commission Agreement',
  [ContractCategory.ResidentialLeaseTenancyAgreement]: 'Residential Lease (Tenancy Agreement)',
  [ContractCategory.RestraintOfTradeAgreementStandAloneDeed]:
    'Restraint of Trade Agreement (Stand-alone Deed)',
  [ContractCategory.RetailLeaseGovernedByStateRetailLeasesActs]:
    'Retail Lease (Governed by State Retail Leases Acts)',
  [ContractCategory.SafeAgreement]: 'SAFE Agreement (Simple Agreement for Future Equity)',
  [ContractCategory.SaasAgreementSoftwareAsAService]: 'SaaS Agreement (Software as a Service)',
  [ContractCategory.SecondmentAgreement]: 'Secondment Agreement',
  [ContractCategory.SecurityAgreement]: 'Security Agreement',
  [ContractCategory.ServiceLevelAgreementSla]: 'Service Level Agreement (SLA)',
  [ContractCategory.ServicesAgreement]: 'Services Agreement',
  [ContractCategory.ShareSaleAgreementSsa]: 'Share Sale Agreement (SSA)',
  [ContractCategory.ShareholdersAgreementSha]: 'Shareholders Agreement (SHA)',
  [ContractCategory.SponsorshipAgreement]: 'Sponsorship Agreement',
  [ContractCategory.SubcontractConstructionOrGeneral]: 'Subcontract (Construction or General)',
  [ContractCategory.SubscriptionAgreement]: 'Subscription Agreement',
  [ContractCategory.SupplyAgreement]: 'Supply Agreement',
  [ContractCategory.TermsAndConditionsTermsOfTrade]: 'Terms and Conditions / Terms of Trade',
  [ContractCategory.TermsOfUse]: 'Terms of Use',
  [ContractCategory.TrustDeedFamilyUnitOrHybridTrust]: 'Trust Deed (Family, Unit, or Hybrid Trust)',
  [ContractCategory.UnitSaleAgreement]: 'Unit Sale Agreement',
  [ContractCategory.WaterEntitlementTransferAgreement]: 'Water Entitlement Transfer Agreement',
  [ContractCategory.WillTestamentaryContractDocument]: 'Will (Testamentary Contract/Document)',
  [ContractCategory.Other]: 'Other',
};

export const contractCategoryOptions: SelectOption<ContractCategory>[] = Object.values(
  ContractCategory,
).map(category => ({
  value: category,
  label: contractCategoryLabels[category],
}));

export const formatContractCategoryLabel = (
  category: ContractCategory | string | null | undefined,
) => {
  if (!category) return '-';
  return contractCategoryLabels[category as ContractCategory] || String(category);
};
